import { CheckCircle, Plus, Minus, Equals } from "@phosphor-icons/react";

const TYPE_STYLE = {
  ADDED:    { icon: Plus,   bg: "bg-green-100", text: "text-green-700" },
  REMOVED:  { icon: Minus,  bg: "bg-red-100",   text: "text-red-700"   },
  MODIFIED: { icon: Equals, bg: "bg-amber-100", text: "text-amber-700" },
};

export default function CompDetail({ compResult, refImg, latImg }) {
  const changes   = compResult.changes || [];
  const unchanged = compResult.unchanged_elements || [];

  return (
    <div className="p-4 space-y-4">
      {(refImg || latImg) && (
        <div className="flex gap-3">
          {refImg && (
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-slate-500 mb-1 uppercase tracking-wide">Reference</p>
              <div className="bg-slate-100 rounded overflow-hidden border border-slate-200 max-h-36">
                <img src={`data:image/jpeg;base64,${refImg}`} alt="Reference" className="w-full h-full object-contain" />
              </div>
            </div>
          )}
          {latImg && (
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-primary mb-1 uppercase tracking-wide">Latest</p>
              <div className="bg-slate-100 rounded overflow-hidden border border-primary/20 max-h-36">
                <img src={`data:image/jpeg;base64,${latImg}`} alt="Latest" className="w-full h-full object-contain" />
              </div>
            </div>
          )}
        </div>
      )}

      {compResult.summary && <p className="text-sm text-slate-600 leading-relaxed">{compResult.summary}</p>}

      {changes.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Changes ({changes.length})</h3>
          <div className="space-y-2">
            {changes.map((c, i) => {
              const ts = TYPE_STYLE[c.type] || TYPE_STYLE.MODIFIED;
              const TypeIcon = ts.icon;
              return (
                <div key={i} className="border border-slate-200 rounded-sm p-2.5">
                  <div className="flex items-start gap-2">
                    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-bold rounded flex-shrink-0 ${ts.bg} ${ts.text}`}>
                      <TypeIcon size={9} weight="bold" />
                      {c.type}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-slate-800">{c.description}</p>
                      {c.location && <p className="text-xs text-slate-400 mt-0.5">{c.location}</p>}
                    </div>
                    {c.significance && (
                      <span className={`flex-shrink-0 text-xs px-1.5 py-0.5 rounded font-medium ${
                        c.significance === "HIGH" ? "bg-red-100 text-red-700"
                        : c.significance === "MEDIUM" ? "bg-amber-100 text-amber-700"
                        : "bg-blue-100 text-blue-700"
                      }`}>{c.significance}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {unchanged.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Unchanged</h3>
          {unchanged.map((el, i) => (
            <div key={i} className="flex items-start gap-2 text-xs text-slate-500 py-0.5">
              <CheckCircle size={11} className="text-green-500 mt-0.5 flex-shrink-0" />
              {el}
            </div>
          ))}
        </div>
      )}

      {compResult.overall_assessment && (
        <p className="text-xs text-slate-500 italic border-t border-slate-100 pt-3">
          {compResult.overall_assessment}
        </p>
      )}
    </div>
  );
}
